import type { DashboardInfo } from '@/lib/store/api/dashboardApi'

/** Dedicated renew-page href from a dashboard overview payload, if a renewal next step is listed. */
export function prescriptionRenewalHrefFromOverview(data: DashboardInfo | undefined): string | undefined {
    const renewalNextStep = data?.care_actions_sorted?.find(
        (careAction) => careAction.class_name === 'NextStep::PrescriptionRenewal' && 'id' in careAction,
    )

    return renewalNextStep && 'id' in renewalNextStep
        ? `/prescriptions/renew/${renewalNextStep.id}`
        : undefined
}
